import { BaseEnum } from "./baseEnum";

const listEnum: Array<TypeOccurrenceDisciplinaryMeasure> = [];

export class TypeOccurrenceDisciplinaryMeasure extends BaseEnum {
    static Verbal = new TypeOccurrenceDisciplinaryMeasure(1, "Verbal", "Advertência verbal", "warning");
    static Written = new TypeOccurrenceDisciplinaryMeasure(
        2,
        "Written",
        "Advertência escrita",
        "warning"
    );
    static Suspension = new TypeOccurrenceDisciplinaryMeasure(
        3,
        "Suspension",
        "Suspensão",
        "danger"
    );

    constructor(
        public id: number,
        public value: string,
        public label: string,
        public className: string
    ) {
        super(id, value, label, className);
        listEnum.push(this);
    }

    public static buildListEnum(): Array<BaseEnum> {
        return listEnum;
    }
}
